import { Building, LifeBuoy, User } from 'lucide-react';
import { useHostNavigate } from '../../../shared/ui';
import type { Distributor } from '../types';
import { Panel } from './panel';

const LINKS = [
  { label: 'Company details', to: '/company-settings', icon: Building },
  { label: 'Your profile', to: '/user-settings', icon: User },
  { label: 'Support', to: '/support', icon: LifeBuoy },
];

/** Who you are signed in as, and the settings pages that go with it. */
export function AccountPanel({ distributor }: { distributor: Distributor | null }) {
  const hostNavigate = useHostNavigate();

  return (
    <Panel title="Your account" subtitle={distributor?.name}>
      {(distributor?.emailAddress || distributor?.phoneNumber) && (
        <p className="text-xs text-hilevel-gray m-0 mb-3">
          {[distributor.emailAddress, distributor.phoneNumber].filter(Boolean).join(' · ')}
        </p>
      )}
      <div className="space-y-1">
        {LINKS.map(({ label, to, icon: Icon }) => (
          <button
            key={to}
            type="button"
            onClick={() => hostNavigate(to)}
            className="flex items-center gap-2.5 w-full px-2 py-1.5 text-left text-sm text-hilevel-slate bg-transparent hover:bg-hilevel-light border-0 rounded-md cursor-pointer transition-colors group"
          >
            <Icon className="w-4 text-hilevel-gray group-hover:text-hilevel-red transition-colors" />
            {label}
          </button>
        ))}
      </div>
    </Panel>
  );
}
